export const pagePadding =
  'w-[calc(100%_-_32px)] my-0 mx-auto md:w-[calc(100%_-_48px)]';
